import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import { useAmplitude } from 'hb-react/shared/hooks/useAmplitude';

import Item from '../Item';

const FiltersBlock = ({ filters }) => {
  const { trackEvent } = useAmplitude();

  const handleFocusTrack = (event, filter) =>
    trackEvent('PeopleDirectory|User selects a field', filter);

  const handleOnChange = (event, filter) =>
    trackEvent('PeopleDirectory|User makes change on field', filter);

  const handleBlurTrack = (event, filter) =>
    trackEvent('PeopleDirectory|User de-selects a field', filter);

  return filters.flatMap((block, index) => {
    if (!block?.filters?.length) {
      return [];
    }

    return (
      <Block
        key={block.block_title}
        mt={block.block_title && index !== 0 && 8}
        data-testid="filter-box"
      >
        <Headline>
          {block.block_title && <Title>{block.block_title}</Title>}
          <Line mt={block.block_title ? 3 : 7} />
        </Headline>
        <Items>
          {block.filters.map((filter) => (
            <Item
              key={filter.name}
              filter={filter}
              ariaLabel={filter.label}
              onFocus={(event) => handleFocusTrack(event, filter)}
              onChange={(event) => handleOnChange(event, filter)}
              onBlur={(event) => handleBlurTrack(event, filter)}
            />
          ))}
        </Items>
      </Block>
    );
  });
};

export default FiltersBlock;

const Block = styled(Box).attrs(() => ({
  display: 'block',
}))``;

const Headline = styled(Box).attrs(() => ({
  flexDirection: 'column',
  mb: 6,
  ml: { _: 0, m: 0 },
  mr: { _: 0, m: 0 },
  pl: 0,
  pr: 0,
}))``;

const Title = styled(Box).attrs(() => ({
  font: 'h3-regular',
  as: 'h3',
}))``;

const Line = styled(Box).attrs(() => ({
  height: 1,
  bg: 'horizon',
  minWidth: '100%',
}))``;

const Items = styled(Box).attrs(() => ({
  pt: 0,
  display: 'block',
  maxWidth: { _: '100%', m: 418, l: 418, xl: 418 },
}))`
  transition: all 0.2s;
`;
